export default {
  labels: {
    order: 'Zamówienie',
    customer: 'Klient',
  },
  tags: {
    new_customer: 'Nowy klient',
    loyal_customer: 'Stały klient',
  },
};
